/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { ConfigsErrors, XError } from '@wit/vtv-x-foundation-lib';
import Env from 'types/Env';
import EnvDefault from '../env.json';

const config: { env: Env } = {
  env: EnvDefault as Env,
};

export default config;

// will retrieve the production env.jon (available in the public folder)
// will replace the local (bundled) env.json
export async function initEnv() {
  if (process.env.NODE_ENV === 'production') {
    const resp = await fetch(`${process.env.PUBLIC_URL}/env.json`);
    if (resp.ok) {
      config.env = await resp.json();
      return config.env;
    }
    return Promise.reject(XError.fromCode(ConfigsErrors.validation.invalidData));
  }
  return config.env;
}
